import styled from "styled-components";

export const BaseContainer = styled.div`
    //dimensions
    height: 100%;
    min-width: inherit;
    min-height: inherit;

    //flex
    display: flex;
    flex-direction: column;
    align-items: center;

    //alignments
    margin: 0 auto;
    padding-top: 45px !important;

    //992px and 1440px
    @media screen and (min-width: 992px) {
        max-width: 1200px;
        padding: 0 16px;
    }

    //768px and 992px
    @media screen and (min-width: 768px) and (max-width: 992px) {
        max-width: 100%;
        padding: 0 32px;
    }

    //576px and 768px
    @media screen and (min-width: 576px) and (max-width: 768px) {
        max-width: 100%;
        padding: 0 32px;
    }

    //576px and below
    @media screen and (max-width: 576px) {
        max-width: 100%;
        padding: 0 32px;
    }
`;
